import Enum from "../../../../../../enums/Enum";

const OnsetEnum = new Enum({
    INSIDIOUS: {name: "Insidious"},
    TRAUMATIC: {name: "Traumatic"},
    SUDDEN: {name: "Sudden"},
    OTHER: {name: "Other"}
});

export default OnsetEnum;